<template>
  <div class="main-ct">
    <div class="info-ct">
      <div class="info-section">
        <p class="info-title">{{ $t('Gamification_BespokeGame_Title') }}</p>
        <p class="info-description">
          {{ $t('Gamification_BespokeGame_Description') }}
        </p>
      </div>
      <div>
        <el-button type="primary" @click="talkToSales()">
          {{ $t('Gamification_BespokeGame_FindOutMore') }}
        </el-button>
      </div>
    </div>
    <div class="img">
      <img src="@/img/gamification/games-dashboard-monster.png" />
    </div>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { customConfirm } from '@/core/helpers'
import { ProductRequestTypesEnum } from '@/common/enum/ProductRequestTypesEnum'
import { ProductRequestOptionsEnum } from '@/common/enum/ProductRequestOptionsEnum'

export default {
  name: 'BespokeGameBanner',
  methods: {
    talkToSales() {
      customConfirm(
        this.$t('Gamification_Book_A_Demo_Interested_In_Gamification_Title'),
        this.$t(
          'Gamification_Book_A_Demo_Interested_In_Gamification_Description'
        ),
        this.$t(
          'Gamification_Book_A_Demo_Interested_In_Gamification_Send_Request'
        ),
        this.$t(
          'Gamification_Book_A_Demo_Interested_In_Gamification_Send_Request_Cancel'
        )
      )
        .then(() => {
          RestApi({
            method: 'post',
            url: `projects/${this.$route.query.project_id}/notification`,
            data: {
              productName: ProductRequestTypesEnum.GAMIFICATION,
              content: ProductRequestOptionsEnum.BESPOKE
            }
          })
            .then(() => {
              this.$message({
                message: this.$t(
                  'Gamification_Book_A_Demo_Interested_In_Gamification_Request_Sent'
                ),
                type: 'success'
              })
            })
            .catch(() => {
              this.$message({
                message: this.$t(
                  'Gamification_Book_A_Demo_Interested_In_Gamification_Request_Failed'
                ),
                type: 'error'
              })
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* relative path was tried but does not work */
  background-image: url('../../../../img/gamification/games-dashboard-banner-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.info-ct {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 40px 30px 30px 50px;
  color: #ffffff;
  width: 440px;
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-title {
  font-size: 17px;
  line-height: 22px;
  font-weight: 700;
}

.info-description {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  text-wrap: balance;
}

.img {
  width: 340px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-dashboard/BespokeGameBanner.vue